// extracted by mini-css-extract-plugin
module.exports = {"mask":"CapturePhoto_mask__1xjMY","message":"CapturePhoto_message__2QL0T","messageTitle":"CapturePhoto_messageTitle__3wL6u","messageTip":"CapturePhoto_messageTip__sZ_p8"};